const {
  isPlainObject,
  cloneDeep
} = require('lodash');
const {
  enumerateWildcardPath,
  mutateContentValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate filterObjectBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined || !isPlainObject(object)) {
    return undefined;
  }
  let result = {};
  const keep = await evaluateSource(source.keep, content, parentContentPath, transientContext, nativeFunctions);
  if (keep !== undefined && Array.isArray(keep)) {
    keep.forEach(wildcardPath => {
      enumerateWildcardPath(object, wildcardPath, (path, value) => {
        mutateContentValue(path, result, value);
      });
    });
  } else {
    result = cloneDeep(object);
  }
  const remove = await evaluateSource(source.remove, content, parentContentPath, transientContext, nativeFunctions);
  if (remove !== undefined && Array.isArray(remove)) {
    remove.forEach(wildcardPath => {
      enumerateWildcardPath(object, wildcardPath, path => {
        mutateContentValue(path, result, null);
      });
    });
  }
  return result;
};
module.exports = {
  evaluate
};